/*
 * Small Småland motifs, drawn in the same quiet line-art language as Ornaments.jsx.
 * Decorative only: no page copy, booking links, or layout-critical content.
 */
export const Linnaea = ({ className = "" }) => (
  <svg className={"smaland-art " + className} viewBox="0 0 200 230" fill="none" aria-hidden="true" focusable="false">
    <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
      <path d="M105 219 C103 179 102 150 99 111 C96 82 105 64 109 39" />
      <path d="M101 165 C82 153 72 138 72 122 M102 149 C117 137 127 121 132 108" />
      <path d="M103 118 C83 104 72 80 64 53 M102 110 C121 94 136 77 149 48" />
      <path d="M64 53 C59 65 53 77 44 81 M149 48 C150 61 158 71 167 73" />
      <path d="M100 185 C81 183 70 174 65 163 M103 179 C122 173 132 164 139 151" />
      <path d="M101 205 C91 197 88 189 89 183" />
      <path d="M72 122 C62 117 56 112 53 105 C65 105 73 111 72 122Z" fill="currentColor" fillOpacity=".16" />
      <path d="M132 108 C142 103 148 98 152 91 C139 93 131 100 132 108Z" fill="currentColor" fillOpacity=".16" />
      <path d="M65 163 C55 160 49 154 46 147 C57 149 65 155 65 163Z" fill="currentColor" fillOpacity=".15" />
      <path d="M139 151 C150 148 156 143 161 136 C150 137 143 142 139 151Z" fill="currentColor" fillOpacity=".15" />
    </g>
    <g fill="#dca7a1" fillOpacity=".82" stroke="#e6beb7" strokeWidth="1.3" strokeLinejoin="round">
      <path d="M31 75 C35 72 42 73 45 77 C50 73 57 75 59 79 C60 93 53 105 46 108 C37 103 30 90 31 75Z" />
      <path d="M152 67 C155 62 163 61 167 65 C171 61 179 63 183 68 C184 83 179 95 169 98 C159 93 152 83 152 67Z" />
    </g>
    <g stroke="#f6eae4" strokeLinecap="round" strokeWidth="1.3">
      <path d="M38 79 L44 96 M52 80 L47 98 M160 70 L167 88 M175 70 L170 88" />
    </g>
    <g fill="currentColor" opacity=".5">
      <circle cx="101" cy="189" r="1.7" /><circle cx="98" cy="140" r="1.2" />
    </g>
  </svg>
);

export const LingonSprig = ({ className = "" }) => (
  <svg className={"smaland-art " + className} viewBox="0 0 190 125" fill="none" aria-hidden="true" focusable="false">
    <g stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <path d="M15 113 C54 95 75 72 104 49 C124 31 141 27 174 14" />
      <path d="M57 84 C47 62 46 45 49 27 M85 61 C89 35 105 20 114 13 M109 46 C133 47 148 58 160 73" />
      <path d="M49 28 C35 24 29 13 29 7 C42 9 51 16 49 28Z" fill="currentColor" fillOpacity=".21" />
      <path d="M50 37 C59 24 71 22 77 23 C72 37 63 42 50 37Z" fill="currentColor" fillOpacity=".23" />
      <path d="M86 62 C70 56 64 47 62 38 C76 42 86 50 86 62Z" fill="currentColor" fillOpacity=".2" />
      <path d="M95 39 C89 25 93 15 99 8 C107 22 104 34 95 39Z" fill="currentColor" fillOpacity=".2" />
      <path d="M121 38 C126 24 140 19 150 20 C144 33 136 39 121 38Z" fill="currentColor" fillOpacity=".22" />
      <path d="M143 55 C156 47 167 47 177 51 C167 60 154 62 143 55Z" fill="currentColor" fillOpacity=".2" />
      <path d="M151 67 C166 69 176 78 180 87 C166 86 154 79 151 67Z" fill="currentColor" fillOpacity=".2" />
      <path d="M61 82 C57 89 56 98 59 107 M74 71 C78 82 84 85 91 88 M109 49 C112 59 116 69 120 78" />
    </g>
    <g fill="#a35a40" stroke="#8b4837" strokeWidth="1.2">
      <circle cx="59" cy="108" r="10" /><circle cx="79" cy="102" r="9" />
      <circle cx="100" cy="92" r="10" /><circle cx="119" cy="80" r="8.5" />
    </g>
    <g stroke="#e5b0a0" strokeWidth="1.1" strokeLinecap="round">
      <path d="M54 104 l3 -3 M75 98 l3 -3 M96 88 l3 -3 M115 77 l2 -2" />
    </g>
  </svg>
);

export const StoneWall = ({ className = "" }) => (
  <svg className={"smaland-art " + className} viewBox="0 0 720 105" fill="none" aria-hidden="true" focusable="false" preserveAspectRatio="xMidYMid meet">
    <g stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" fill="#b7b4a4" fillOpacity=".09">
      <path d="M36 87 L65 71 L118 72 L138 88 L120 99 L69 99Z" />
      <path d="M128 83 L145 62 L199 61 L220 83 L207 98 L141 99Z" />
      <path d="M214 86 L234 67 L289 70 L301 88 L287 99 L226 98Z" />
      <path d="M298 83 L316 65 L371 63 L388 84 L371 99 L308 99Z" />
      <path d="M384 83 L399 66 L457 63 L479 84 L462 98 L399 99Z" />
      <path d="M475 85 L491 66 L547 66 L569 87 L553 99 L486 98Z" />
      <path d="M565 84 L587 68 L640 70 L664 88 L644 99 L581 99Z" />
      <path d="M77 67 L95 50 L148 52 L161 68 L141 78 L92 78Z" />
      <path d="M151 56 L177 39 L223 45 L233 65 L212 76 L165 76Z" />
      <path d="M227 63 L249 42 L306 43 L322 64 L303 77 L246 77Z" />
      <path d="M314 57 L336 40 L388 44 L397 65 L379 76 L326 74Z" />
      <path d="M394 64 L414 44 L467 44 L486 65 L470 77 L410 77Z" />
      <path d="M481 60 L501 43 L550 48 L572 67 L558 79 L497 76Z" />
      <path d="M568 66 L592 51 L633 51 L647 71 L629 80 L586 77Z" />
      <path d="M116 45 L134 27 L172 30 L185 40 L166 52 L129 52Z" />
      <path d="M236 40 L251 27 L287 28 L305 40 L287 49 L249 49Z" />
      <path d="M370 39 L392 24 L425 30 L435 44 L407 50 L383 47Z" />
      <path d="M517 40 L530 27 L568 31 L581 48 L555 54 L527 50Z" />
    </g>
    <g stroke="currentColor" strokeWidth="1.15" strokeLinecap="round" opacity=".65">
      <path d="M18 101 Q24 86 26 73 M26 90 Q16 84 14 79 M29 86 Q37 77 39 72" />
      <path d="M676 100 Q680 81 680 70 M680 90 Q670 81 668 77 M681 85 Q691 76 693 69" />
      <path d="M340 99 q-4 -10 -3 -17 M339 91 q-5 -3 -8 -6" />
    </g>
  </svg>
);

export const Otter = ({ className = "" }) => (
  <svg className={"smaland-art " + className} viewBox="0 0 210 108" fill="none" aria-hidden="true" focusable="false">
    <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
      <path d="M45 72 C56 64 62 49 79 43 C96 36 105 41 122 44 C137 47 145 37 153 30 C160 24 171 25 179 33 C188 38 193 49 189 56 C184 63 171 65 162 64 C145 79 127 80 109 77 C93 75 77 78 61 82 C46 86 30 85 15 79 C8 75 8 67 17 66 C27 66 35 70 45 72Z" fill="currentColor" fillOpacity=".12" />
      <path d="M146 40 C143 31 151 27 157 28 C160 22 169 22 174 28" />
      <path d="M97 75 C94 84 89 88 80 89 M133 73 C132 84 124 87 117 87" />
      <path d="M167 63 q6 4 16 0 M164 61 q10 -1 23 2" strokeWidth="1" />
      <path d="M190 57 l8 1 M190 53 l10 -3 M190 60 l9 5" strokeWidth="1" />
      <path d="M38 75 C32 74 26 73 20 72" strokeWidth="1" />
    </g>
    <circle cx="174" cy="42" r="2.3" fill="currentColor" />
    <circle cx="190" cy="55" r="2" fill="currentColor" />
    <path d="M9 96 Q46 88 80 96 M104 99 Q144 91 186 97" stroke="currentColor" strokeOpacity=".45" strokeLinecap="round" strokeWidth="1.3" />
  </svg>
);

export const TimberGate = ({ className = "" }) => (
  <svg className={"smaland-art " + className} viewBox="0 0 310 110" fill="none" aria-hidden="true" focusable="false">
    <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
      <path d="M12 102 L12 40 L18 34 L25 40 L25 101 M285 101 L285 41 L292 35 L299 41 L299 102" />
      <path d="M25 57 L82 57 M25 79 L82 79 M226 57 L285 57 M226 79 L285 79" />
      <path d="M82 102 L82 31 L90 25 L98 31 L98 101 M211 101 L211 31 L219 25 L227 31 L227 102" />
      <path d="M98 45 L211 45 L211 98 L98 98Z" fill="currentColor" fillOpacity=".045" />
      <path d="M100 92 L207 49 M100 55 L199 98" strokeWidth="1.4" />
      <path d="M114 45 V98 M136 45 V98 M158 45 V98 M180 45 V98 M202 45 V98" strokeWidth="1.35" />
      <circle cx="203" cy="76" r="2.5" fill="currentColor" />
      <path d="M2 103 Q30 99 61 103 M71 104 Q147 100 237 104 M245 104 Q280 99 307 103" strokeWidth="1.1" />
      <path d="M6 98 L3 86 M35 103 L40 91 M277 102 L271 92 M305 101 L310 91" strokeWidth="1.1" />
    </g>
  </svg>
);
